import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SelectComponent } from '../../select/select.component';
import { userServices } from 'src/app/services/users.service';
import { firstValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { leadServices } from 'src/app/services/leads.service';
import { DialogComponent } from '../../dialog/confirm.dialog';

@Component({
  selector: 'app-owner',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    SelectComponent,
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule
  ],
  templateUrl: './owner.component.html',
  styleUrl: './owner.component.scss'
})
export class OwnerComponent implements OnInit{
  users:any[]=[]
  ownerForm:FormGroup;
  currentOwner:string;

  constructor(
    public dialogRef: MatDialogRef<OwnerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb:FormBuilder,
    private userService:userServices,
    private leadService:leadServices,
    private dialog:MatDialog
  ) {
    // Add conditional validation based on type
    this.ownerForm = this.fb.group({
      newOwner: ['', this.data.type === 'user' ? Validators.required : []] // Only required for primary owner
    });
  }
  
  ngOnInit(): void {
    const leadData = this.data?.lead?.[this.data.type];
    this.currentOwner = leadData
      ? `${leadData['name']} ${leadData['lastName']}`
      : 'No owner assigned';

    this.initData();

    // Show error immediately for required owner field if empty
    if (this.data.type === 'user' && !leadData) {
      this.ownerForm.get('newOwner')?.markAsTouched();
    }
  }

  async initData(): Promise<void> {
    try {
      const users = await firstValueFrom(this.userService.get());
      this.users = users.data.map((row) => {
        return { id: row.id, name: row.name + ' ' + row.lastName, firstName: row.name, lastName: row.lastName };
      });
      const leadData = this.data?.lead?.[this.data.type];
      if (leadData) {
        this.ownerForm.patchValue({
          newOwner: leadData['id']?.toString() || '',
        });
      }
    } catch (error) {
      console.error('Failed to fetch users:', error);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  async save() {
    const { newOwner: value } = this.ownerForm.value;
    const leadData = this.data?.lead?.[this.data.type];
  
    // For secondary owner, allow empty/null values
    if (this.data.type === 'secondaryUser' && !value) {
      // Clear secondary owner
      const obj = { [this.data.type]: null };
      const response = await firstValueFrom(this.leadService.patchOwner(obj, this.data.lead.id));
      if(response){
        const result = {
          data:response,
          type:this.data.type,
          success:true
        }
        this.dialogRef.close(result);
      }
      return;
    }

    if (!leadData || +value !== +leadData['id']) {
      const obj = { [this.data.type]: value };
      const response = await firstValueFrom(this.leadService.patchOwner(obj, this.data.lead.id));
      if(response){
        const result = {
          data:response,
          type:this.data.type,
          success:true
        }
        this.dialogRef.close(result);
      }
    } else {
      await this.callDialog(
        'Duplicate Assignment',
        'The lead is already assigned to this owner. No changes have been made.',
        '500px',
        true,
        'warning'
      );
    }
  }

  callDialog(header: string, content: string,width='500px',isInfo=false,type?) {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        header,
        content,
        isInfo,
        type
      },
      width,
    });

    return dialogRef.afterClosed().toPromise();
  }
}